import { Component, Inject, Injectable, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { APP_CONFIG } from '../../../../config/app-config.module';
import { AppConfig } from '../../../../core/config-models/app-config.model';
import * as verifyEmailActions from '../../actions/verify-email.actions';
import { ActivatedRoute } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import * as fromVerifyEmailSelector from '../../selectors/verify-email.selectors';
import { IVerifyEmailResponse } from '../../models/verify-email.model';

@Injectable({
  providedIn: 'root'
})
@Component({
  selector: 'app-verify-email',
  templateUrl: './verify-email.component.html',
  styleUrls: ['./verify-email.component.css']
})
export class VerifyEmailComponent implements OnInit, OnDestroy {
  token: string;
  message: string;
  verifyEmailObservable$: Observable<IVerifyEmailResponse>;
  verifyEmailSubscription: Subscription = new Subscription();

  constructor(
    private activatedRoute: ActivatedRoute,
    private store: Store,
    @Inject(APP_CONFIG) private appConfig: AppConfig
  ) {
    this.message = "Confirming your email...";
    this.activatedRoute.queryParams.subscribe(params => {
      this.token = params['token'];
    });
  }

  ngOnInit(): void {
    var reqst = { token: this.token };
    this.store.dispatch(verifyEmailActions.verifyEmailRequest({ request: reqst}));
    this.message = 'Verifying......';

    this.verifyEmailObservable$ = this.store.select(fromVerifyEmailSelector.getVerifyEmailResponse);
    this.verifyEmailSubscription = this.verifyEmailObservable$.subscribe(response => {
      if(response){
        if (response.success) {
          this.message = 'Congratulations! Your email verified successfully.';
        }else{
          if(response.otpExpired)
            this.message = 'This link is already expired :(';
          else
            this.message = 'Email verification failed :(';
        }
      }
    });
  }

  ngOnDestroy(): void{
    this.verifyEmailSubscription.unsubscribe();
  }
}
